<div class="col-sm-6 col-md-6 col-lg-4">
  <p>
    <strong>POLÍTICA DO EVENTO</strong> <br />
    Cancelamento de pedidos pagos <br />Cancelamentos de pedidos serão aceitos até 7 dias após a compra, desde que a
    solicitação seja enviada até 48 horas antes do início do evento. <br />
    Entre em contato para mais informações
  </p>
  <div class="d-flex" style="gap: 16px">
    <a
      (keypress)="('https://www.facebook.com/yes7tickets/')"
      (keydown)="('https://www.facebook.com/yes7tickets/')"
      (keyup)="('https://www.facebook.com/yes7tickets/')"
      tabindex="0"
      href="https://www.facebook.com/yes7tickets"
      rel="noopener"
      target="_blank">
      <i class="pi pi-facebook"></i>
      Facebook
    </a>
    <a
      (keypress)="('https://www.instagram.com/yes7tickets/')"
      (keydown)="('https://www.instagram.com/yes7tickets/')"
      (keyup)="('https://www.instagram.com/yes7tickets/')"
      tabindex="0"
      href="https://www.instagram.com/yes7tickets/"
      target="_blank"
      rel="noopener">
      <i class="pi pi-instagram"></i>
      Instagram
    </a>
    <a
      (keydown)="('contato@yes7tickets.net')"
      (keyup)="('contato@yes7tickets.net')"
      (keyup)="('contato@yes7tickets.net')"
      tabindex="0"
      href="mailto:contato@yes7tickets.net"
      rel="noopener noreferrer"
      target="_blank">
      <i class="pi pi-envelope"></i>
      Email
    </a>
  </div>
</div>
